<template>
  <f7-page>
    <f7-navbar
      v-if="mostrarNavbarFrm"
      sliding
      no-shadow
      :style="appTheme"
    >
      <div class="lefth">
        <f7-link back>
          <img
            alt="iconBack"
            src="@/static/icons/back.svg"
          >
        </f7-link>
      </div>
    </f7-navbar>

    <UCPreload :show="mostrarPrecarga" />

    <!-- Mensaje Información sin plantillas -->
    <span
      v-if="!mostrarPrecarga && listaPlantillasTipoEnvasadoDisponibles != null && listaPlantillasTipoEnvasadoDisponibles.length === 0"
      class="span-texto-azulOscuro-18-500"
    > No hay plantillas disponibles para los puntos de paletizado seleccionados</span>

    <div
      v-if="!mostrarPrecarga"
      class="div-plantillasDisponibles"
      aria-dropeffect="none"
    >
      <div
        v-for="plantilla in listaPlantillasTipoEnvasadoDisponibles"
        :key="plantilla.Id"
        class="div-elementoTarjeta seleccionable"
      >
        <f7-row class="row-cabeceraTarjeta">
          <f7-col
            width="60"
            style="margin-left: 10px;"
          >
            <span class="span-texto-azulOscuro-18-500 span-textoCabeceraTarjetaPlantilla"> {{ plantilla.PuntoPaletizado.Codigo }} </span>
          </f7-col>
          <f7-col
            width="40"
            class="div-cabeceraTarjetaDerecha"
          >
            <span
              class="btn-oval-azulOscuro-26 btn-eliminarPlantilla"
              @click="EliminarPlantilla(plantilla)"
            >
              {{ $t('common.x') }}
            </span>
          </f7-col>
        </f7-row>
        <f7-row class="row-plantilla">
          <f7-col width="100">
            <f7-row class="row-producto">
              <f7-col width="100" />
              <span class="span-texto-azulOscuro-16-500">
                {{ plantilla.TipoEnvasado.Articulo.Nombre }}
              </span>
            </f7-row>

            <f7-row class="row-envase">
              <f7-col width="100" />
              <span class="span-texto-gris-14-500">
                {{ plantilla.TipoEnvasado.Envase.Nombre }}
              </span>
            </f7-row>

            <f7-row class="row-paleYCamara">
              <f7-col width="100" />
              <span class="span-texto-azulOscuro-14-500">
                {{ plantilla.TipoEnvasado.Pale.Nombre }}
              </span>
            </f7-row>

            <f7-row class="row-paleYCamara">
              <f7-col width="100" />
              <span class="span-texto-azulOscuro-14-500">
                {{ plantilla.TipoEnvasado.Marca.Nombre }}
              </span>
            </f7-row>
          </f7-col>
        </f7-row>
      </div>
    </div>
    <div class="div-elementoSeparador-90 div-separador" />
    <div class="div-opcionesActions">
      <f7-row>
        <f7-col
          width="50"
          class="col-izquierdaActions"
        >
          <a
            class="link link-izquierdaActions-2"
            @click="CancelarEdicion()"
          >
            {{ $t('common.cancel').toUpperCase() }}
          </a>
        </f7-col>
        <f7-col
          width="50"
          class="col-derechaActions"
        >
          <a
            class="link link-derechaActions-2"
            @click="ConfirmarEdicion()"
          >
            {{ $t('common.confirm').toUpperCase() }}
          </a>
        </f7-col>
      </f7-row>
    </div>
  </f7-page>
</template>

<script>
import { mapState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';

import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import SoporteGeneral from '@/js/common/HICommonSupport';
import {
  HiNotification,
} from '@/js/common/HINotificationSupport';
import UCPreload from '@/components/common/UCPreload.vue';

export default {
  name: 'FrmFamilyPreparationTemplatesModels',
  components: {
    UCPreload,
  },

  props: {
    activo: {
      type: Boolean,
      default: true,
    },
    mostrarNavbarFrm: {
      type: Boolean,
      default: true,
    },
  },

  emits: [
    'cerrarFrm',
    'plantillasTipoEnvasadoActualizadas',
  ],

  data() {
    return {
      lineaProduccionSeleccionadaLocal: null, // Linea Producción Seleccionada.
      partidaSeleccionadaLocal: null, // Mantiene la partidaSeleccionadaLocal en la variable global para obtener las plantillas de la misma familia.
      listaPlantillasTipoEnvasadoDisponibles: null, // Mantendra la lista de las plantillas  con los tipos de envasado disponibles.
      mostrarPrecarga: false, // Muestra la precarga dpara obtener las plantillas.
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'partidaSeleccionada',
      'lineaDeProduccionSeleccionada',
    ]),

    appTheme() {
      return {
        '--f7-navbar-text-color': '#fff',
      };
    },
  },
  watch: {
    activo(val) {
      if (val != null && val !== false) {
        this.InicializarFrm();
      }
      if (val != null && val === false) {
        this.RestablecerValores();
      }
    },
  },

  methods: {
    InicializarFrm() {
      Log(this, this.InicializarFrm.name);
      this.partidaSeleccionadaLocal = this.partidaSeleccionada;
      this.lineaProduccionSeleccionada = this.lineaDeProduccionSeleccionada;
      if (this.partidaSeleccionadaLocal == null || this.lineaProduccionSeleccionada == null) {
        this.CancelarEdicion();
        HiNotification.Toast('Es necesario establecer una linea de producción y una partida');
      }
      const self = this;
      this.mostrarPrecarga = true;
      const idsPuntosPaletizado = SoporteGeneral.ObtenerCadenaIds(this.lineaProduccionSeleccionada.PuntosDePaletizado);
      this.ObtenerPlantillasDeTipoEnvasadoParaPuntosDePaletizado(this.partidaSeleccionadaLocal.Partida.Articulo.Familia.Id, idsPuntosPaletizado)
        .then((result) => {
          self.mostrarPrecarga = false;
          self.listaPlantillasTipoEnvasadoDisponibles = result;
        })
        .catch((error) => {
          self.listaPlantillasTipoEnvasadoDisponibles = null;
          self.mostrarPrecarga = false;
          HiNotification.Toast(error);
        });
    },

    RestablecerValores() {
      Log(this, this.RestablecerValores.name);
      this.lineaProduccionSeleccionadaLocal = null;
    },

    CancelarEdicion() {
      Log(this, this.CancelarEdicion.name);
      this.$emit('cerrarFrm');
      this.RestablecerValores();
    },

    ConfirmarEdicion() {
      Log(this, this.ConfirmarEdicion.name);
      this.$emit('plantillasTipoEnvasadoActualizadas', this.listaPlantillasTipoEnvasadoDisponibles);
      this.$emit('cerrarFrm');
      this.RestablecerValores();
    },

    EliminarPlantilla(plantilla) {
      Log(this, this.EliminarPlantilla.name);
      const tempIndexPlantilla = this.listaPlantillasTipoEnvasadoDisponibles.findIndex((p) => (p.Id === plantilla.Id));
      this.listaPlantillasTipoEnvasadoDisponibles.splice(tempIndexPlantilla, 1);
    },

    ObtenerPlantillasDeTipoEnvasadoParaPuntosDePaletizado(idFamiliaArticulo, idsPuntosPaletizado) {
      Log(this, this.ObtenerPlantillasDeTipoEnvasadoParaPuntosDePaletizado.name);
      const self = this;
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerPlantillasDeTipoEnvasadoParaPuntosDePaletizado(
          idFamiliaArticulo,
          idsPuntosPaletizado,
        ).then((result) => {
          if (result.Valor) {
            resolve(JSON.parse(result.Mensaje));
          } else {
            reject(result.Mensaje);
            HiNotification.Toast(result.Mensaje);
          }
        })
          .catch((error) => {
            LogError(self, self.ObtenerPlantillasDeTipoEnvasadoParaPuntosDePaletizado.name, error);
            reject();
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          });
      });
    },
  },
};
</script>

<style scoped>
.div-cantidadEnvasesPorPale {
  margin: 10px;
}

.input-1 {
  width: 100%;
  padding-top: 21px;
  padding-left: 17px;
  color: var(--his-ash-gray);
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  text-align: left;
}

.row-elementosFrm {
  margin-left: 10px;
  margin-right: 25px;
  margin-bottom: 5px;
}

.div-opcionesActions {
  width: 94%;
  bottom: 10px;
  position: absolute;
}

.div-separador {
  width: 94%;
  bottom: 45px;
  position: absolute;
}

.div-cabeceraFormulario {
  margin-left: 22px;
  margin-top: 10px;
}

.col-opcionesDerecha {
  text-align: -webkit-right;
  padding-right: 31px;
}

.div-plantillasDisponibles {
  margin: 22px;
  margin-bottom: 5px;
  margin-top: 10px;
  max-height: 100%;
  height: 51vh;
  overflow-y: auto;
}

.div-elementoTarjeta {
  background-color: #fff;
  box-shadow: 0 2px 11px 0 rgb(56 62 68 / 9%);
  color: var(--his-steel-blue);
  font-size: 15px;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
  margin-top: 15px;
  vertical-align: middle;
  border: 2px solid #d4d4d4;
  border-radius: 4px;
}

.div-elementoTarjeta .row-cabeceraTarjeta {
  min-height: 34px;
  background-color: #d4d4d4;
  border-radius: 4px 4px 0 0;
  align-items: center;
}

.span-textoCabeceraTarjetaPlantilla {
  margin-left: 10px;
  margin-right: 10px;
}

.row-plantilla {
  margin-top: 10px;
  margin-left: 10px;
  margin-right: 10px;
}

.row-producto {
  margin-top: 3px;
}

.row-envase {
  margin-top: 3px;
}

.row-paleYCamara {
  margin-top: 3px;
}

.btn-eliminarPlantilla {
  margin-right: 13px;
}

.div-cabeceraTarjetaDerecha {
  text-align: -webkit-right;
}
</style>
